import { Redirect, Route } from 'react-router-dom';
// eslint-disable-next-line no-unused-vars
import React, {Component, useEffect, useRef, useState} from "react";
import { decodeIdToken, getAccessToken } from "./authUtil";
import useUserStore from "../hook/useUserStore";
import CircularProgress from "@material-ui/core/CircularProgress";

const ProtectedRoute = ({ component: Component, path, exact }) => {
    const [loading, setLoading] = useState(false);
    const isAuth = useUserStore((state) => state.isAuth);
    const setIsAuth = useUserStore((state) => state.setIsAuth);
    const checkedRef = useRef(false);

    useEffect(() => {
        if (checkedRef.current) return;
        let cancelled = false;
        setLoading(true);
        getAccessToken()
            .then(accessToken => {
                if (cancelled) return;
                const decoded = decodeIdToken(accessToken);
                checkedRef.current = true;
                if (accessToken && decoded && isAuth !== true) setIsAuth(true);
                if (!accessToken || !decoded) setIsAuth(false);
            })
            .catch(() => { if (!cancelled) setIsAuth(false); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [isAuth]);

    if(loading) return <CircularProgress className="loading-button-spinner"/>;

    if(!isAuth) {
        return (
            <Route
                path={path}
                exact={exact}
                render={props =>
                    <Component {...props} />
                }
            />
        );
    } else {
        return (
            <Route
                path={path}
                exact={exact}
                render={ props =>
                    <Redirect to="/" />
                }
            />
    )};
};

export default ProtectedRoute;
